import styled from "styled-components";

export const ListAdress = styled.div`
  margin-top: 20px;
  .all_address {
    background-color: #fbfbfb;
    padding: 8px 12px;
    margin-bottom: 10px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  h4 {
    margin-bottom: 0;
  }
  .check_address {
    width: 80%;
    height: 80%;
    border-radius: 50%;
  }
`
export const ListAutoComplet = styled.div`
  & .items_address {
    border-bottom: 1px solid #00000077;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  & .items_address p {
    margin: 0;
  }
  & .items_address span {
    font-size: 24px;
    color: black;
  }
`